import React, {useEffect, useRef, useState} from "react";
import styles from './archiveFlyer.module.scss'
import {PageSpinner} from "../../../../com/pagesTab/pagesSpinner/spinner";
import {FlyerDto, FlyersStateForArchiveAndDeletedFlyersDto, ItemsListMenuDto, UserDto} from "../../../../../dtos";
import moment from "moment";
import ReactTooltip from "react-tooltip";
import './../../flyer.scss';
import {ReactComponent as MenuOnHover} from "../../../../../assets/flyersScreen/3_dots_icon.svg";
import {hideMenu} from "react-contextmenu/modules/actions";
import {
    dispatchEventDataType,
    EVENT_DATA_TYPE_DISABLE_TABS,
    EVENT_DATA_TYPE_TITLE_HEADER_DATA_CHANGE
} from "../../../../../globals/EventDispatcher";
import {Button, Typography} from "@mui/material";
import {
    MenuForPromotion
} from "../../../promos/leftMenu/LeftMenuContent/LeftMenuContentElement/MenuForPromotions/menuForPromotions";

interface FlyerItem {
    flyerDto: FlyerDto;
    openFlyerDetails: (rowIndex: number, flyerDto: FlyerDto) => void;
    isActive: boolean;
    flyerIndex: number;
    // onHardDeleteFlyer: (a: any) => void;
    onSoftDeleteFlyer: () => void;
    onRestoreFlyer: () => void;
    doubleClickOnFlyer: () => void;
    flyersState: FlyersStateForArchiveAndDeletedFlyersDto,
    changeFlyersState: (e: FlyersStateForArchiveAndDeletedFlyersDto) => void
}


export const ArchiveFlyer: React.FC<FlyerItem> = (props) => {
    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr!);
    const isUserViewer = userDto.role !== 2 && userDto.role !== 3;
    const [tooltip, setTooltip] = useState('');

    const [didLoad, onLoad] = useState(false);
    const [notLoad, onNotLoad] = useState(false);
    const anchorRefForFlyerMenu = useRef(null);
    const [isOpenedFlyerMenu, setOpenFlyerMenu] = useState(false);
    const prevOpenFlyerMenu = useRef(isOpenedFlyerMenu);

    const clickMenuDataForFlyer: ItemsListMenuDto = {
        setOpen: setOpenFlyerMenu,
        prevOpen: prevOpenFlyerMenu,
        open: isOpenedFlyerMenu,
        anchorRef: anchorRefForFlyerMenu,
    };

    const loaded = () => {
        onLoad(true);
    }

    const loadedWithError = () => {
        onNotLoad(true);
    }

    useEffect(() => {
        setTooltip(`Job Code: ${props.flyerDto.flyCode}
        Number of Pages: ${props.flyerDto.flyerPages?.length}
        Flyer Status: Archived
        Start Date: ${moment(props.flyerDto.flyValidFromUtc).format('DD MMM YYYY')}
        End Date: ${moment(props.flyerDto.flyValidToUtc).format('DD MMM YYYY')}
        Created Date: ${moment(props.flyerDto.flyCreatedUtc).format('DD MMM YYYY')}
        Last Modified: ${moment(props.flyerDto.flyModifiedUtc).format('DD MMM YYYY')}`)
    });

    const deleteOrRestoreFlyer = (isDelete: boolean) => {
        if (isDelete) {
            props.onSoftDeleteFlyer();
        } else {
            props.onRestoreFlyer();
        }
        // const id = props.flyerDto.flyRecId;
        // if(isDelete){
        //     props.onSoftDeleteFlyer(id);
        // } else {
        //     props.onRestoreFlyer(id);
        // }
    }


    let timer: any = 0;
    let delay = 100;
    let prevent = false;

    const doClickAction = (e: React.MouseEvent<HTMLElement>) => {
        const target = e.target as HTMLElement;
        const tagName = target.tagName;
        const isMenuOption = target.classList.contains("menuOption");
        if (tagName === "BUTTON" || tagName === "LABEL" || tagName === "SELECT" || tagName === "INPUT" || (tagName && isMenuOption)) {
            return;
        }
        dispatchEventDataType<string | undefined>(EVENT_DATA_TYPE_DISABLE_TABS, true);
        hideMenu();
        const clickedFlyerAlreadyActive = props.flyersState.activeFlyers.find((flyer: FlyerDto) => flyer.flyRecId === props.flyerDto.flyRecId);
        if (e.button === 2) {
            if (!clickedFlyerAlreadyActive) {
                dispatchEventDataType<string | undefined>(EVENT_DATA_TYPE_TITLE_HEADER_DATA_CHANGE, props.flyerDto.flyCaption);
                hideMenu();
                props.changeFlyersState({
                    ...props.flyersState,
                    activeFlyers: [props.flyerDto],
                    lastActivatedFlyer: props.flyerDto
                });
            }
        } else if (!clickedFlyerAlreadyActive || props.flyersState.activeFlyers.length > 1) {
            if (e.ctrlKey || e.metaKey || e.shiftKey && props.flyersState.lastActivatedFlyer) {
                if (e.ctrlKey || e.metaKey) {
                    if (props.isActive) {
                        props.changeFlyersState({
                            ...props.flyersState,
                            activeFlyers: props.flyersState.activeFlyers.filter((activeFlyer: FlyerDto) => {
                                if (props.flyerDto.flyRecId !== activeFlyer.flyRecId) {
                                    return activeFlyer
                                }
                            }),
                            lastActivatedFlyer: props.flyerDto
                        })
                    } else {
                        props.changeFlyersState({
                            ...props.flyersState,
                            activeFlyers: [...props.flyersState.activeFlyers, props.flyerDto],
                            lastActivatedFlyer: props.flyerDto
                        })
                    }
                }
                if (e.shiftKey && props.flyersState.lastActivatedFlyer && props?.flyerDto) {
                    const isSelectedFlyerIndexBiggerOrEqualThanLastSelectedFlyerIndex = props?.flyerDto?.index! >= props?.flyersState.lastActivatedFlyer.index!;
                    props.changeFlyersState({
                        ...props.flyersState,
                        activeFlyers: props.flyersState.flyersData.filter((flyer: FlyerDto, index: number) => {
                            if (isSelectedFlyerIndexBiggerOrEqualThanLastSelectedFlyerIndex) {
                                if (props?.flyersState.lastActivatedFlyer?.index! <= index && props?.flyerDto?.index! >= index) {
                                    return flyer;
                                }
                            } else {
                                if (props?.flyersState.lastActivatedFlyer?.index! >= index && props?.flyerDto?.index! <= index) {
                                    return flyer;
                                }
                            }
                        })
                    })
                }
            } else {
                dispatchEventDataType<string | undefined>(EVENT_DATA_TYPE_TITLE_HEADER_DATA_CHANGE, props.flyerDto.flyCaption);
                hideMenu();
                props.changeFlyersState({
                    ...props.flyersState,
                    activeFlyers: [props.flyerDto],
                    lastActivatedFlyer: props.flyerDto
                });
            }

        } else {
            console.log('one click');
            dispatchEventDataType<string | undefined>(EVENT_DATA_TYPE_TITLE_HEADER_DATA_CHANGE, props.flyerDto.flyCaption);
            props.changeFlyersState({
                ...props.flyersState,
                activeFlyers: [props.flyerDto],
                lastActivatedFlyer: props.flyerDto
            })
        }
    }
    const doDoubleClickAction = () => {
        console.log('double click');
        props.doubleClickOnFlyer()
        // props.openFlyerDetails(props.flyerIndex, props.flyerDto)
    }
    const handleClick = (e: React.MouseEvent<HTMLElement>) => {
        timer = setTimeout(function () {
            if (!prevent) {
                doClickAction(e)
            }
            prevent = false;
        }, delay);
    }
    const handleDoubleClick = () => {
        clearTimeout(timer);
        prevent = true;
        doDoubleClickAction();
    }

    const handleToggleForFlyer = (e: React.MouseEvent<HTMLButtonElement>) => {
        setOpenFlyerMenu((prevOpen) => !prevOpen);
    };


    const imageUrl = props?.flyerDto?.flyerPages!.length ? (props?.flyerDto?.flyerPages[0].flyImageThumbnailUrl ? props?.flyerDto?.flyerPages[0].flyImageThumbnailUrl : '') : '';
    return (
        <>
            <div
                data-for={props.flyerDto.flyRecId?.toString()}
                data-tip
                className={`${styles.flyer} ${props.isActive ? styles.flyer_active : ''}`}
                onClick={handleClick}
                // onDoubleClick={handleDoubleClick}
                onContextMenu={doClickAction}
            >
                <div>
                    <div data-img={imageUrl}>
                        {/*<Img src={imageUrl} loader={<PageSpinner/>}*/}
                        {/*     alt="img"/>*/}
                        {!notLoad && <>
                            <img className={didLoad ? '' : styles.hide_image}
                                 src={imageUrl || ""}
                                 onLoad={loaded}
                                 onError={loadedWithError}
                                 alt='not uploaded'
                            />
                            {
                                !didLoad && <PageSpinner/>
                            }
                        </>}

                    </div>

                </div>
                <div className={styles.flyer_footer}>
                    <Typography noWrap fontWeight={700} fontSize={"12px"} textAlign={"center"} flex={"1 1 auto"}>
                        {props.flyerDto.flyCaption}
                    </Typography>
                    {
                        props.isActive &&
                        <>
                            <Button
                                sx={{
                                    width: "24px",
                                    height: "24px",
                                    opacity: isUserViewer ? "0.2" : "1",
                                    "&:hover": {
                                        backgroundColor: "#88888833"
                                    }
                                }}
                                // disableRipple={true}
                                ref={anchorRefForFlyerMenu}
                                aria-controls={
                                    isOpenedFlyerMenu
                                        ? "menu-list-grow"
                                        : undefined
                                }
                                aria-haspopup="true"
                                disabled={isUserViewer}
                                onClick={handleToggleForFlyer}
                            >
                                <MenuOnHover style={{pointerEvents: "none"}}/>
                            </Button>
                            <MenuForPromotion
                                list={clickMenuDataForFlyer}
                                handleDeleteRestoreClick={deleteOrRestoreFlyer}
                                // handleDeleteClick={userDto.accountTier === 1 ? handleDeleteClick : softDeleteFlyer}
                                infoForMenu={`menuForFlyerArchive`}
                            />
                        </>
                    }
                </div>
            </div>
            <ReactTooltip
                aria-haspopup='true'
                id={props.flyerDto.flyRecId?.toString()}
                offset={{'top': 10, 'left': 5}}
                role='example'
                delayShow={1000}
                className={`${styles.tooltip} tooltip_custom`}
            >
                <div>
                    {tooltip}
                </div>

            </ReactTooltip>
        </>
    )
}